module.exports = __webpack_public_path__ + "img/paso1-img.cb81d547.png";